import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// Styles
import useStyles from './MenuOutOfStockView.styles'
// Components
import Conditional from '../common/conditional'
import CustomLoader from '../common/custom-loader'
import { ProductOutstockList } from './product-outstock-list'
import { ToppingBoxesList } from './topping-outstock-list'

const MenuOutOfStockView = ({
  classes,
  isLoading,
  productsOutOfStock,
  toppingsOutOfStock,
}) => {
  const componentClasses = useStyles()
  return (
    <div className={classNames(componentClasses.root)}>
      <CustomLoader open={isLoading} />
      <Conditional if={!!productsOutOfStock.length}>
        <ProductOutstockList products={productsOutOfStock} />
      </Conditional>
      <Conditional if={!!toppingsOutOfStock.length}>
        <ToppingBoxesList toppings={toppingsOutOfStock} />
      </Conditional>
    </div>
  )
}

MenuOutOfStockView.defaultProps = {
  classes: {},
  productsOutOfStock: [],
  toppingsOutOfStock: [],
}

MenuOutOfStockView.propTypes = {
  productsOutOfStock: PropTypes.array,
  toppingsOutOfStock: PropTypes.array,
  onChangeProductAvailability: PropTypes.func,
  onChangeToppingAvailability: PropTypes.func,
  productDeactivationOptions: PropTypes.array,
}

export default MenuOutOfStockView
